import { useQuery } from "@apollo/react-hooks";

import { Learner } from "@hubcapp/types";
import getLearnerProgressQuery from "../graph-ql/getLearnerProgress.graphql";

const useGetLearnerProgressQuery = (id?: string) =>
  useQuery<{ learner: Learner }>(getLearnerProgressQuery, {
    variables: {
      id,
    },
    skip: !id,
  });

export default useGetLearnerProgressQuery;
